import { Route, Routes } from "react-router-dom";
import React from "react";
import { Domain } from "src/config/BartLambdaConfig";
import { TransactionSearch } from "src/pages/transactionSearch/transactions";
import { FusePlan } from "src/pages/fusePlan/fusePlan";
import { GetArdRedirect } from "src/pages/fuseArd/GetArdRedirect";
import { JemGen } from "src/pages/jemGen/jemGen";
import { UpdateFusePlan } from "src/pages/updateFusePlan/updateFusePlan";
import { RedriveWorkflow } from "src/pages/redriveWorkflow/redrives";
import { BulkRedriveWorkflow } from "src/pages/bulkRedriveWorkflow/bulkRedrives";
import { BulkRedriveStatus } from "src/pages/bulkRedriveStatus/bulkRedriveStatus";
import { BartAuditHistory } from "src/pages/bartAuditHistory/bartAuditHistory";
import { DlqMoverWorkflow } from "src/pages/dlqmoverWorkflow/dlqmover";
import { WorkflowStatus } from "src/pages/workflowStatus/workflowStatus";
import { LinkArdToAFusePlan } from "src/pages/remappingArdToPlan/linkArdToAFusePlan";
import { ArdNewPlanMapping } from "src/pages/ardNewPlanMapping/ardNewPlanMapping";
import { URLS } from "src/components/constants/appConstants";
import { RagaAvailabilities } from "../pages/raga-availabilities";
import { AllFixedFeeConfigs } from "../pages/allFixedFeeConfigs/allFixedFeeConfigs";
import { FixedFeeConfig } from "src/pages/fixedFeeConfig/fixedFeeConfig";
import { JemValidation } from "src/pages/jemGenValidation/jemValidation";
import { UnbilledArAging } from "src/pages/unbilledArAging/unbilledArAging";

interface Props {
  domain: Domain;
}

export const BartRoutes = (props: Props) => {
  return (
    <Routes>
      <Route path="/">
        <Route
          path="transactionsearch/:type/:id/version/:version"
          element={<TransactionSearch domain={props.domain} />}
        />
        <Route
          path="transactionsearch/:type/:id"
          element={<TransactionSearch domain={props.domain} />}
        />
        <Route
          path="transactionsearch"
          element={<TransactionSearch domain={props.domain} />}
        />
        <Route path="" element={<TransactionSearch domain={props.domain} />} />
      </Route>
      <Route path="/getplan">
        <Route path=":id" element={<FusePlan domain={props.domain} />} />
        <Route path="" element={<FusePlan domain={props.domain} />} />
      </Route>
      <Route path="/getard">
        <Route path=":id" element={<GetArdRedirect />} />
        <Route path="" element={<GetArdRedirect />} />
      </Route>
      <Route path="/updateplan">
        <Route path=":id" element={<UpdateFusePlan />} />
        <Route path="" element={<UpdateFusePlan />} />
      </Route>
      <Route path={URLS.RAGA_AVAILABILITIES} element={<RagaAvailabilities />} />
      <Route path="/redriveworkflow" element={<RedriveWorkflow />} />
      <Route path="/bulkredriveworkflow" element={<BulkRedriveWorkflow />} />
      <Route path="/bulkredrivestatus">
        <Route
          path=":id"
          element={<BulkRedriveStatus domain={props.domain} />}
        />
        <Route path="" element={<BulkRedriveStatus domain={props.domain} />} />
      </Route>
      <Route path="/bartaudithistory" element={<BartAuditHistory />} />
      <Route path="/bartdlqmoverworkflow" element={<DlqMoverWorkflow />} />
      <Route path="/getworkflowstatus" element={<WorkflowStatus />} />
      <Route path="/remappingardtoplan">
        <Route path=":id" element={<LinkArdToAFusePlan />} />
        <Route path="" element={<LinkArdToAFusePlan />} />
      </Route>
      <Route path="/ardnewplanmapping" element={<ArdNewPlanMapping />} />
      <Route path="/jemgen" element={<JemGen />} />
      <Route path={URLS.GET_FIXED_FEE_CONFIG}>
        <Route path=":id" element={<FixedFeeConfig />} />
        <Route path="" element={<FixedFeeConfig />} />
      </Route>
      <Route
        path={URLS.LIST_ALL_FIXED_FEE_CONFIGS}
        element={<AllFixedFeeConfigs />}
      />
      <Route path={URLS.JEM_VALIDATION} element={<JemValidation />} />
      <Route path={URLS.UNBILLED_AR_AGING} element={<UnbilledArAging />} />
    </Routes>
  );
};
